"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var selectors_1 = __importDefault(require("../selectors"));
var Playback_1 = require("../utils/Playback");
var usePlayerSettings = function (assetId) {
    var profileId = react_redux_1.useSelector(selectors_1.default.customer.selectedProfileId);
    var textTracks = react_redux_1.useSelector(selectors_1.default.playback.getTextTracksByMediaAssetId)(assetId);
    var selectedTextTrackByProfileId = react_redux_1.useSelector(selectors_1.default.customer.getSelectedTextTrackByProfileId)(profileId);
    var selectedTextTrack = Playback_1.matchingSelectedTextTrack(textTracks, selectedTextTrackByProfileId);
    return { selectedTextTrack: selectedTextTrack };
};
exports.default = usePlayerSettings;
//# sourceMappingURL=usePlayerSettings.js.map